import { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";

const SearchBox = ({
  basePath = "/search",
  defaultPath = "/shop",
  placeholder = "Search Products...",
}) => {
  const navigate = useNavigate();
  const { keyword: urlKeyword } = useParams();
  const [keyword, setKeyword] = useState(urlKeyword || "");

  useEffect(() => {
    setKeyword(urlKeyword || "");
  }, [urlKeyword]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (keyword.trim()) {
      navigate(`${basePath}/${encodeURIComponent(keyword.trim())}`);
    } else {
      navigate(defaultPath);
    }
  };

  return (
    <Form onSubmit={submitHandler} className="d-flex">
      <Form.Control
        type="text"
        name="q"
        onChange={(e) => setKeyword(e.target.value)}
        value={keyword}
        placeholder={placeholder}
        className="mr-sm-2 ml-sm-5"
      ></Form.Control>
      <Button type="submit" variant="primary" className="p-2 mx-2">
        Search
      </Button>
    </Form>
  );
};
export default SearchBox;
